import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import FlightRouteService from "services/FlightRouteService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllFlightRoute = createAsyncThunk(
  "flightRoute/getAllFlightRoute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await FlightRouteService.getAll();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllActiveFlightRoute = createAsyncThunk(
  "flightRoute/getAllActiveFlightRoute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await FlightRouteService.getAllActive();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createFlightRoute = createAsyncThunk(
  "flightRoute/createFlightRoute",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await FlightRouteService.createFlightRoute(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateFlightRoute = createAsyncThunk(
  "flightRoute/updateFlightRoute",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await FlightRouteService.updateFlightRoute(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteFlightRoute = createAsyncThunk(
  "flightRoute/deleteFlightRoute",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await FlightRouteService.deleteFlightRoute(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  flightRouteList: [],
  flightRouteActiveList: [],
};

export const flightRouteSlice = createSlice({
  name: "flightRoute",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAllFlightRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllFlightRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.flightRouteList = action.payload;
      })
      .addCase(getAllFlightRoute.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAllActiveFlightRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllActiveFlightRoute.fulfilled, (state, action) => {
        state.loading = false;
        state.flightRouteActiveList = action.payload;
      })
      .addCase(getAllActiveFlightRoute.rejected, (state) => {
        state.loading = false;
      })

      .addCase(createFlightRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFlightRoute.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createFlightRoute.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateFlightRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFlightRoute.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateFlightRoute.rejected, (state) => {
        state.loading = false;
      })

      .addCase(deleteFlightRoute.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFlightRoute.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteFlightRoute.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = flightRouteSlice.actions;

export default flightRouteSlice.reducer;
